import { QCNamingConvention } from './qc-naming-convention';
import { QCDomesticOnlyNamingConvention } from './qc-domestic-only-naming-convention';
import { QCDomesticSourceMasterNamingConvention } from './qc-domestic-source-master-naming-convention';
import { QCProductionMasterNamingConvention } from './qc-production-master-naming-convention';
import { QCSAWFilesNamingConvention } from './qc-saw-files-naming-convention';
import { QCTapeAssetNamingConvention } from './qc-tape-asset-naming-convention';

export class QCNamingConventions {

  static conventionForComponents(components: Partial<QCNamingConvention>): QCNamingConvention {

    let tape_formats = [
      "D5",
      "DigiBeta",
      "DVCPro 100",
      "HDCam",
      "HDCamSR 4:2:2",
      "HDCamSR 4:4:4"
    ]
    if (tape_formats.find((x) => x == components.format) != null &&
        QCTapeAssetNamingConvention.hasAllRequiredComponents(components)) {
      return new QCTapeAssetNamingConvention(components);
    }

    if (components.elementType == "Production Master" &&
        QCProductionMasterNamingConvention.hasAllRequiredComponents(components)) {
      return new QCProductionMasterNamingConvention(components);
    }

    if (components.elementType == "Domestic Source Master") {
      if (QCDomesticSourceMasterNamingConvention.hasAllRequiredComponents(components)) {
        return new QCDomesticSourceMasterNamingConvention(components);
      } else if ((components.foreignEpisode == null || components.foreignEpisode.trim() == '') &&
        QCDomesticOnlyNamingConvention.hasAllRequiredComponents(components)) {
        return new QCDomesticOnlyNamingConvention(components);
      }
    }

    if (QCSAWFilesNamingConvention.hasAllRequiredComponents(components)) {
      return new QCSAWFilesNamingConvention(components);
    }

    return null;
  }

}


// WEBPACK FOOTER //
// ./src/app/qc/qc-naming-conventions/qc-naming-conventions.ts